import { useState, useEffect } from 'react'
import { supabase } from './supabase'

// Default content used when Supabase is not configured or data hasn't loaded
const defaults = {
  hero_title: 'סדנת נשים מעצימה — מאיה נח והילה אילוז',
  hero_subtitle: 'מחפשת סדנת נשים? הצטרפי למסעות של תנועה, רוחניות, התפתחות אישית ושקט פנימי.',
  hero_image: '',
  about_title: 'מי אנחנו',
  about_company_title: 'סדנאות נשים והעצמה',
  about_company_text: 'מאיה נח והילה אילוז מובילות נשים למסע של חיבור עצמי דרך תנועה, יצירה ומרחבים מאפשרים בטבע.',
  about_maya_name: 'מאיה נח',
  about_maya_text: 'מנחה רוחנית ומורה ליוגה עם ניסיון של שנים בליווי נשים בתהליכי צמיחה אישית. מאמינה בכוח של תנועה, נשימה וחיבור לגוף.',
  about_maya_image: '',
  about_hila_name: 'הילה אילוז',
  about_hila_text: 'מנחת מדיטציה ומטפלת הוליסטית. מלווה נשים בדרכן למציאת שקט פנימי, איזון ומשמעות דרך סדנאות ומפגשים אישיים.',
  about_hila_image: '',
  contact_title: 'צרי קשר',
  contact_text: 'רוצה לשמוע עוד? השאירי פרטים ונחזור אלייך בהקדם',
  contact_email: '',
  whatsapp_number: '',
  whatsapp_number_2: '',
  logo_type: 'text',
  logo_text: 'מאיה והילה',
  logo_image: '',
  gallery_title: 'תמונות מאירועים קודמים',
  gallery_images: [],
}

export function useContent() {
  const [content, setContent] = useState(() => {
    // Try to load cached content from localStorage for instant initial render
    const cached = localStorage.getItem('site_content_cache')
    return cached ? JSON.parse(cached) : defaults
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchContent()
  }, [])

  async function fetchContent() {
    try {
      const { data, error } = await supabase
        .from('site_content')
        .select('key, value')

      if (error) throw error

      if (data && data.length > 0) {
        const mapped = { ...defaults }
        data.forEach(row => {
          if (row.key === 'gallery_images') {
            try {
              mapped[row.key] = typeof row.value === 'string' ? JSON.parse(row.value) : row.value;
              if (!Array.isArray(mapped[row.key])) mapped[row.key] = [];
            } catch {
              mapped[row.key] = [];
            }
          } else {
            mapped[row.key] = row.value
          }
        })
        setContent(mapped)
        // Cache the fetched content for next time
        localStorage.setItem('site_content_cache', JSON.stringify(mapped))
      }
    } catch {
      // Use defaults if Supabase is not configured
    } finally {
      setLoading(false)
    }
  }

  return { content, loading }
}

export function useProject() {
  const [project, setProject] = useState(() => {
    // Try to load cached project from localStorage
    const cached = localStorage.getItem('site_project_cache')
    return cached ? JSON.parse(cached) : null
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchProject()
  }, [])

  async function fetchProject() {
    try {
      const { data, error } = await supabase
        .from('project')
        .select('*')
        .eq('is_active', true)
        .order('created_at', { ascending: false })
        .limit(1)
        .single()

      if (error) throw error

      // Ensure details object exists
      const sanitized = {
        ...data,
        details: data.details || { includes: [], images: [] }
      }
      setProject(sanitized)
      // Cache the fetched project for next time
      localStorage.setItem('site_project_cache', JSON.stringify(sanitized))
    } catch {
      // No active project or error
      setProject(null)
    } finally {
      setLoading(false)
    }
  }

  return { project, loading }
}
